import { uid } from 'radash';

import {
    ComponentInstanceValidationError,
    ComponentInstanceValidationErrorType,
    ComponentInstanceValidator,
} from 'models';

const powerVoltageDroop: ComponentInstanceValidator['validator'] = ({ diagram }) => {
    const errors: ComponentInstanceValidationError[] = [];

    Object.values(diagram.componentInstances).forEach((componentInstance) => {
        if (componentInstance.disabled) return;

        componentInstance.configuration.ports.forEach((port, portIndex) => {
            if (port.controlMethod !== 'power-voltage') return;

            const points = port.voltageSeries?.value?.length ?? 0;

            if (points === 0) {
                errors.push({
                    id: uid(6),
                    type: ComponentInstanceValidationErrorType.REQUIRED_CONFIGURATION_POWER_VOLTAGE_DROOP,
                    level: 'error',
                    payload: { componentInstance, portIndex },
                });
            }
        });
    });

    return errors;
};

export { powerVoltageDroop };
